import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'sort',
    standalone: true
})
export class SortPipe implements PipeTransform {

  // transform(value: Array<string>, args: any[]): any {

  //   const sortField = args[0];
  //   const sortDirection = args[1];
  //   let multiplier = 1;

  //   if (sortDirection === 'desc') {
  //     multiplier = -1;
  //   }

  //   value.sort((a: any, b: any) => {
  //     if (a[sortField] < b[sortField]) {
  //       return -1 * multiplier;
  //     } else if (a[sortField] > b[sortField]) {
  //       return 1 * multiplier;
  //     } else {
  //       return 0;
  //     }
  //   }
  //   );

  //   return value;
  // }
  // transform(value: any[], sortField: string, sortDirection: string): any[] {
  //   if (!value || !sortField || !sortDirection) {
  //     return value;
  //   }


  //   let multiplier = sortDirection === 'desc' ? -1 : 1;
  //   value.sort((a: any, b: any) => {
  //     if (typeof a[sortField] === 'string' && typeof b[sortField] === 'string') {
  //       return a[sortField].localeCompare(b[sortField]) * multiplier;
  //     } else if (typeof a[sortField] === 'object' && typeof b[sortField] === 'object') {
  //       switch (sortField) {
  //         case "owner":
  //           return (a[sortField]?.name?.localeCompare(b[sortField]?.name ?? '') ?? 0) * multiplier;
  //           break;
  //         case "devices":
  //         case "users":
  //           return ((a[sortField]?.length ?? 0) - (b[sortField]?.length ?? 0)) * multiplier;
  //           break;
  //         case "network":
  //           return (a[sortField]?.type?.localeCompare(b[sortField]?.type ?? '') ?? 0) * multiplier;
  //           break;
  //         case "phone":
  //           return (a[sortField]?.imei?.localeCompare(b[sortField]?.imei ?? '') ?? 0) * multiplier;
  //           break;
  //         case "provider":
  //           return (a[sortField]?.name?.localeCompare(b[sortField]?.name ?? '') ?? 0) * multiplier;
  //           break;
  //         case "group":
  //           return (a[sortField]?.originName?.localeCompare(b[sortField]?.originName ?? '') ?? 0) * multiplier;
  //           break;
  //         default:
  //           return ((a[sortField]?.length ?? 0) - (b[sortField]?.length ?? 0)) * multiplier;
  //       }
  //     }
  //     else {
  //       return (a[sortField] - b[sortField]) * multiplier;
  //     }
  //   });

  //   return value;
  // }
  transform(value: any[], sortField: string, sortDirection: string): any[] {  
      

    // Return an empty array if value is not an array or if sortField/sortDirection are invalid  
    if (!Array.isArray(value) || !sortField || !sortDirection) {  
        return [];  
    }  

    let multiplier = sortDirection === 'desc' ? -1 : 1;  

    value.sort((a: any, b: any) => {  
        const aValue = a[sortField];  
        const bValue = b[sortField];  

        // Check if sortField exists on both objects  
        if (aValue === undefined || bValue === undefined) {  
            return 0; // or handle as needed  
        }  

        if (typeof aValue === 'string' && typeof bValue === 'string') {  
            return aValue.localeCompare(bValue) * multiplier;  
        } else if (typeof aValue === 'object' && typeof bValue === 'object') {  
            switch (sortField) {  
                case "owner":  
                    return (aValue?.name?.localeCompare(bValue?.name ?? '') ?? 0) * multiplier;  
                case "devices":  
                case "users":  
                    return ((aValue?.length ?? 0) - (bValue?.length ?? 0)) * multiplier;  
                case "network":  
                    return (aValue?.type?.localeCompare(bValue?.type ?? '') ?? 0) * multiplier;  
                case "phone":  
                    return (aValue?.imei?.localeCompare(bValue?.imei ?? '') ?? 0) * multiplier;  
                case "provider":  
                    return (aValue?.name?.localeCompare(bValue?.name ?? '') ?? 0) * multiplier;  
                case "group":  
                    return (aValue?.originName?.localeCompare(bValue?.originName ?? '') ?? 0) * multiplier;  
                default:  
                    return ((aValue?.length ?? 0) - (bValue?.length ?? 0)) * multiplier;  
            }  
        } else if (typeof aValue === 'number' && typeof bValue === 'number') {  
            return (aValue - bValue) * multiplier;  
        } else {  
            // Handle cases where types are not comparable  
            return 0; // or some default behavior  
        }  
    });  
    return value;  
}  
}
